import React, { useState } from "react";

import SideBar from "./home/SideBar";
import LocationBar from "./home/LocationBar";
import LocationTopBar from "./home/LocationTopBar";
import CategorieBar from "./home/CategorieBar";
import TableContent from "./home/TableContent";
import IntegraSettings from "./home/IntegrationSettingsPage";
import BiBetaPage from "./home/BiBetaPage";
import Dash from "./home/Dash";

import Busy from "./Busy";
import Notify from "./Notify";
import { useSelector } from "react-redux";

import dots from "../assets/dots.svg";

// ⬇️ v5 routing
import { Switch, Route } from "react-router-dom";

const Home = () => {
  const [dashMain, setDashMain] = useState(true);
  const [page, setPage] = useState(0);
  const [extended, setExtended] = useState(false);
  const ui = useSelector((state) => state.ui);
  const [showSideBar, setShowSideBar] = useState(true);

  return (
    <div className="home">
      {showSideBar && <SideBar setDashMain={setDashMain} />}

      <div
        className="centered side-bar-toggle"
        onClick={() => setShowSideBar((old) => !old)}
      >
        <img src={dots} alt="burger dots" />
      </div>

      {/* ⬇️ Rute: /integration-settings prikazuje Integrations; / ostalo tvoj dosadašnji sadržaj */}
      <Switch>
        <Route path="/integration-settings" component={IntegraSettings} />
        <Route path="/bi-beta" component={BiBetaPage} />

        <Route path="/" exact>
          {dashMain ? (
            <Dash />
          ) : (
            <div className="main-section relative">
              {ui.notify.show && <Notify />}
              {ui.busy && <Busy />}
              <LocationTopBar setExtended={setExtended} extended={extended} />
              <LocationBar extended={extended} />
              <CategorieBar page={page} setPage={setPage} />
              <TableContent page={page} />
            </div>
          )}
        </Route>
      </Switch>
    </div>
  );
};

export default Home;
